import React from 'react';
import { Provider } from 'react-redux';

import { ConfigProvider } from 'ha/helpers/config';
import { IntlProvider, IntlObject } from 'ha/i18n';
import { ServicesProvider } from 'ha/services/ServicesContext';
import { AppServices } from 'ha/services/getAppServices';
import { theme } from '@ha/dsl';
import { ThemeProvider } from '@material-ui/core';
import { StylesProvider } from '@material-ui/core/styles';

import { Store } from 'redux';
import { Config } from 'ha/config';

import ErrorBoundary from 'ha/components/ErrorBoundary';
import createGenerateClassName from 'ha/utils/createGenerateClassName';

const generateClassName = createGenerateClassName();

interface Props {
  store: Store;
  config: Config;
  intl: IntlObject;
  services: AppServices;
}

const AppContextProvider: React.FC<Props> = ({
  store,
  config,
  intl,
  services,
  children,
}) => (
  <StylesProvider generateClassName={generateClassName}>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <ConfigProvider value={config}>
          <ServicesProvider value={services}>
            <IntlProvider value={intl}>
              <ErrorBoundary>{children}</ErrorBoundary>
            </IntlProvider>
          </ServicesProvider>
        </ConfigProvider>
      </Provider>
    </ThemeProvider>
  </StylesProvider>
);

export default AppContextProvider;
